import type { ReactNode } from 'react';
import React, { createContext, useContext, useState } from 'react';

// Define the shape of our context
interface ClearNoteContextType {
  clearText: boolean;
  setClearText: React.Dispatch<React.SetStateAction<boolean>>;
}

const ClearNoteContext = createContext<ClearNoteContextType | null>(null);

// Provider component
export const ClearNoteProvider = ({ children }: { children: ReactNode }) => {
  const [clearText, setClearText] = useState(false); // State for managing the textarea content

  return (
    <ClearNoteContext.Provider value={{ clearText, setClearText }}>
      {children}
    </ClearNoteContext.Provider>
  );
};

// Custom hook to access the context
export const useClearNoteArea = () => {
  const context = useContext(ClearNoteContext);
  if (!context) {
    throw new Error('useTextArea must be used within a TextAreaProvider');
  }
  return context;
};
